import React from 'react';

import FilterPanel from './FilterPanel';
import BotFilters from './BotFilters';

import withStickyScrollNewLayout from '../withStickyScrollNewLayout';

const EnhancedFilterPanel = withStickyScrollNewLayout(FilterPanel);

const FilterPanelDesktop = (props) => {
    if (props.isBotRequest) {
        return <BotFilters slug={props.locationSlug} />;
    }

    const handleFilterChange = (...args) => {
        props.onFilterChange(...args);
        props.handleDrawerSelect('');

        // Scroll back to top of screen, otherwise
        // it looks strange
        window.scrollTo(0, 0);
    };

    return (
        <EnhancedFilterPanel
            {...props}
            style={{ maxWidth: '320px' }}
            onFilterChange={handleFilterChange}
        />
    );
};

export default FilterPanelDesktop;
